export const menu = [{
    route : '/create',
    icon: 'location_on',
    variant: '',
    label: 'Create'
  },
  {
    route : '/analyse',
    icon: 'search',
    variant: '',
    label: 'Analyse'
  },
  {
    route : '/Edit',
    icon: 'edit',
    variant: '',
    label: 'Edit'
  },
  {
    route : '/account',
    icon: 'manage_accounts',
    variant: '-outlined',
    label:'Account',
  },
  
];


